import React, { useState } from "react";
import "./Setnewpass.css";
import key from "../../images/key.svg";
import Form from "react-bootstrap/Form";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { MdVisibilityOff, MdVisibility } from "react-icons/md";
import { useFormik } from "formik";
import * as Yup from "yup";
import { changePassword } from "../services/providerService";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

function SetnewpassComponent() {
  const location = useLocation();
  const navigate = useNavigate();
  const { provider } = location.state || {};
  const token = useSelector((state) => state?.login?.data?.accessToken);
  // Password visibility state
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  // Formik form setup with validation
  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Old password is required"),
      newPassword: Yup.string()
      .min(8, "New password must be at least 8 characters")
      .matches(/[A-Z]/, "New password must contain at least one uppercase letter") // At least one uppercase letter
      .matches(/\d/, "New password must contain at least one number") // At least one number
      .required("New password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm password is required"),

    }),
    onSubmit: async (values) => {
      const response = await changePassword(values, token);
      if(response.status === 200){
              navigate(-1);
            
      }else{
        toast.error("Failed to reset password")
      }
    
    },
  });

  // Toggle password visibility
  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword((prev) => !prev);

  return (
    <>
      <section className="setpass-blk-main">
        <div className="setpass-text-blk d-flex align-items-center">
          
              
          <div className="setpass-content">
            <div className="keyicon">
              <img src={key} alt="key" />
            </div>
            <div className="setpass-main-text">
              <h2>Set New Password</h2>
              <p>
                Your new password must be different from previously used
                passwords.
              </p>

              <Form onSubmit={formik.handleSubmit}>
                <Form.Group className="mb-3 setpass-inputs" controlId="oldPassword">
                  <Form.Label>Old Password</Form.Label>
                  <Form.Control
                  className="mb-0"
                    type={showPassword ? "text" : "password"}
                    placeholder="Old Password"
                    name="oldPassword"
                    value={formik.values.oldPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.touched.oldPassword && formik.errors.oldPassword
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.oldPassword}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3 setpass-inputs" controlId="newPassword">
                  <Form.Label>New Password</Form.Label>
                  <Form.Control className="mb-0"
                    type={showPassword ? "text" : "password"}
                    placeholder="New Password"
                    name="newPassword"
                    value={formik.values.newPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.touched.newPassword && formik.errors.newPassword
                    }
                  />
                  <Form.Control.Feedback type="invalid" className="mt-0">
                    {formik.errors.newPassword}
                  </Form.Control.Feedback>
                  <div
                    onClick={togglePasswordVisibility}
                    className="password-icon"
                  >
                    {showPassword ? <MdVisibility /> : <MdVisibilityOff />}
                  </div>
                </Form.Group>

                <Form.Group className="mb-3 setpass-inputs" controlId="confirmPassword">
                  <Form.Label>Confirm Password</Form.Label>
                  <Form.Control
                    type={showConfirmPassword ? "text" : "password"}
                    className="mb-0"
                    placeholder="Confirm Password"
                    name="confirmPassword"
                    value={formik.values.confirmPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.touched.confirmPassword &&
                      formik.errors.confirmPassword
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.confirmPassword}
                  </Form.Control.Feedback>
                  <div
                    onClick={toggleConfirmPasswordVisibility}
                    className="password-icon"
                  >
                    {showConfirmPassword ? (
                      <MdVisibility />
                    ) : (
                      <MdVisibilityOff />
                    )}
                  </div>
                </Form.Group>

                <Link
                  to="/passresetdone"
                  variant="primary"
                  className="dark-btn reset-btn"
                  onClick={formik.handleSubmit}
                >
                  Reset Password
                </Link>
              </Form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SetnewpassComponent;

